// extracted by mini-css-extract-plugin
export default {"site_desciption":"SiteDescription_site_desciption__AwN2E","close_btn":"SiteDescription_close_btn__FGKbQ"};